import type { DealParticipant, DealParticipantApi } from '@openx/types/deal';
import { isDateGreaterThan } from '@openx/utils/lib/compareDates';
import { AMAZON_DEAL_SYNC_START_DATE, AMAZON_DEMAND_PARTNER_ID } from '@openx/utils/services/config';
import { useMemo } from 'react';

export const useIsLegacyAmazonDeal = (
  createdDate?: string,
  dealParticipants?: DealParticipant[] | DealParticipantApi[]
): boolean =>
  useMemo(() => {
    const isAmazonDeal = !!dealParticipants?.some(
      participant => participant.demand_partner === AMAZON_DEMAND_PARTNER_ID
    );

    return (
      isAmazonDeal &&
      !!createdDate &&
      !!AMAZON_DEAL_SYNC_START_DATE &&
      !isDateGreaterThan(createdDate, AMAZON_DEAL_SYNC_START_DATE)
    );
  }, [createdDate, dealParticipants]);
